/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

import { DThemeChartOverview } from "../../d-chart-overview";
import { DThemeWhiteBase } from "./d-theme-white-base";

export class DThemeWhiteChartOverview extends DThemeWhiteBase implements DThemeChartOverview {}
